<template>
  <div>
    <h5 class="card-title">邮箱账号</h5>
    <h6 class="card-subtitle text-muted">设置企业接收和发送邮件的地址</h6><hr>
    <form>
      <validation-observer ref="mailForm">

        <fieldset>
          <legend>接收邮件设置</legend>

          <div class="form-row">
            <div class="col-md-6">
              <validation-provider
                :rules="{required: true, max: 50}"
                name="IMAP服务器地址"
                v-slot="validationContext"
              >
                  <b-form-group label="IMAP服务器地址" :invalid-feedback="validationContext.errors[0]">
                    <b-form-input 
                      type="text"
                      v-model="mailboxInfo.recieveServerUrl" 
                      :state="validateState(validationContext)"
                      placeholder="imap.host.com">
                    </b-form-input>
                  </b-form-group>
                
              </validation-provider>
            </div>
            <div class="col-md-4">
                <validation-provider
                  :rules="{required: true, between: [1, 65535]}"
                  name="收件端口"
                  v-slot="validationContext">
                  <b-form-group label="端口" :invalid-feedback="validationContext.errors[0]">
                    <b-form-input 
                      type="text"
                      v-model="mailboxInfo.recievePort" 
                      :state="validateState(validationContext)"
                      placeholder="端口">
                    </b-form-input>
                  </b-form-group>

                </validation-provider>
            </div>
            <div class="col-md-2">
                  <b-form-group label="安全链接" >
                    <b-form-checkbox 
                      type="text"
                      v-model="mailboxInfo.recieveHttps" 
                      >安全链接
                    </b-form-checkbox>
                  </b-form-group>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-6">
                <validation-provider
                  :rules="{ required: true }"
                  name="用户名"
                  v-slot="validationContext">

                  <b-form-group label="用户名" :invalid-feedback="validationContext.errors[0]">
                    <b-form-input 
                      type="text"
                      v-model="mailboxInfo.recieveUser" 
                      :state="validateState(validationContext)"
                      placeholder="用户名">
                    </b-form-input>
                  </b-form-group>
                </validation-provider>
            </div>
            <div class="col-md-6">
                <validation-provider
                  :rules="{ required: true }"
                  name="密码"
                  v-slot="validationContext">

                  <b-form-group label="密码" :invalid-feedback="validationContext.errors[0]">
                    <b-form-input 
                      type="password"
                      v-model="mailboxInfo.recievePassword" 
                      :state="validateState(validationContext)"
                      placeholder="密码">
                    </b-form-input>
                  </b-form-group>
                </validation-provider>
            </div>
          </div>
        </fieldset>
        
        <fieldset>
          <legend>发送邮件设置</legend>
          <div class="form-row">
            <div class="col-md-6">
                <validation-provider
                  :rules="{ required: true ,max:50}"
                  name="SMTP服务器地址"
                  v-slot="validationContext">
                  <b-form-group label="SMTP服务器地址" :invalid-feedback="validationContext.errors[0]">
                    <b-form-input 
                      type="text"
                      v-model="mailboxInfo.sendServerUrl" 
                      :state="validateState(validationContext)"
                      placeholder="smtp.host.com">
                    </b-form-input>
                  </b-form-group>
                </validation-provider>
            </div>
            <div class="col-md-4">
                <validation-provider
                  :rules="{ required: true, between: [1, 65535] }"
                  name="端口"
                  v-slot="validationContext">
                  <b-form-group label="端口" :invalid-feedback="validationContext.errors[0]">
                    <b-form-input 
                      type="text"
                      v-model="mailboxInfo.sendPort" 
                      :state="validateState(validationContext)"
                      placeholder="端口">
                    </b-form-input>
                  </b-form-group>
                </validation-provider>
            </div>
            <div class="col-md-2">
                  <b-form-group label="安全链接" >
                    <b-form-checkbox 
                      type="text"
                      v-model="mailboxInfo.sendHttps" 
                      >安全链接
                    </b-form-checkbox>
                  </b-form-group>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-4">
                <validation-provider
                  :rules="{ required: true }"
                  name="用户名"
                  v-slot="validationContext">

                  <b-form-group label="用户名" :invalid-feedback="validationContext.errors[0]">
                    <b-form-input 
                      type="text"
                      v-model="mailboxInfo.sendUser" 
                      :state="validateState(validationContext)"
                      placeholder="用户名">
                    </b-form-input>
                  </b-form-group>
                </validation-provider>
            </div>
            <div class="col-md-4">
                <validation-provider
                  :rules="{ required: true }"
                  name="密码"
                  v-slot="validationContext">

                  <b-form-group label="密码" :invalid-feedback="validationContext.errors[0]">
                    <b-form-input 
                      type="password"
                      v-model="mailboxInfo.sendPassword" 
                      :state="validateState(validationContext)"
                      placeholder="密码">
                    </b-form-input>
                  </b-form-group>
                </validation-provider>
            </div>
            <div class="form-group col-md-4">
                <validation-provider
                  :rules="{ required: true, max:50 }"
                  name="发件人的友好名称"
                  v-slot="validationContext">

                  <b-form-group label="发件人的友好名称" :invalid-feedback="validationContext.errors[0]">
                    <b-form-input 
                      type="text"
                      v-model="mailboxInfo.sendPersonel" 
                      :state="validateState(validationContext)"
                      placeholder="如：集团财务部">
                    </b-form-input>
                  </b-form-group>
                </validation-provider>
            </div>
          </div>                        
        </fieldset>

        <a type="button" class="btn btn-primary" @click="test">测试连接</a>
        <a type="button" class="btn btn-primary mx-3" :disabled="saveButtonDisabled" @click="save">保存</a>
      </validation-observer>
    </form>
  </div>
</template>

<script>
import * as mailboxFacade from "../../../api/mailbox-facade.js";

export default {
  // validations:
  props:{
    orgId: String,
  },
  data() {
    return {
      mailboxInfo: {},
      saveButtonDisabled: true,
    };
  },

  created() {
    this.getMailboxInfo(this.orgId)
  },
  mounted() {},
  methods: {
    validateState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    getMailboxInfo(orgId){
      this.pageLoading = true;
      mailboxFacade
        .obtain(orgId)
        .then(res => {
          this.pageLoading = false;
          this.mailboxInfo = res;
        })
        .catch(err => {
          console.log("err", err);
          this.pageLoading = false;
        });

    },
    save(){
      this.$refs.mailForm.validate().then(valid => {
        if (valid) {
          mailboxFacade
            .save(this.mailboxInfo)
            .then(()=>{
              this.$message({
                message: "邮箱配置保存成功",
                type: "success"
              });
            })
            .catch(err => {
              console.log("err", err);
              this.pageLoading = false;
            });
        }
      })
    },
    test(){
      this.$refs.mailForm.validate().then(valid => {
        if (valid) {
          mailboxFacade
            .testconnection(this.mailboxInfo)
            .then(()=>{
              this.saveButtonDisabled = false;
              this.$message({
                message: "邮件服务器测试连接成功，您可以点击保存按钮就行保存",
                type: "success"
              });
            })
            .catch(err => {
              console.log("err", err);
              this.pageLoading = false;
            });
        }
      })
    }
  }
};
</script>

<style >
</style>
